// Extoril header: (1) the dropdown "peek" plate shows a real product from the row under the
// pointer; (2) the country pickers load their full list on first use instead of every page
// shipping 237 countries twice. No dependencies; safe to include more than once.
(() => {
  if (window.__exHeader) return;
  window.__exHeader = true;
  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // 1. Dropdown peek
  const cache = new Map();
  const lookup = (handle) => {
    if (!cache.has(handle)) {
      cache.set(handle, fetch(`${root()}collections/${encodeURIComponent(handle)}/products.json?limit=1`)
        .then((r) => (r.ok ? r.json() : null))
        .then((j) => {
          const p = j && j.products && j.products[0];
          const src = p && p.images && p.images[0] && p.images[0].src;
          return src ? { src, title: p.title } : null;
        })
        .catch(() => null));
    }
    return cache.get(handle);
  };
  const pointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const wake = (panel) => {
    const img = panel.querySelector('[data-exhd-peek] img[data-src]');
    if (img) { img.src = img.dataset.src; img.removeAttribute('data-src'); }
  };
  const armPanels = () => {
    for (const panel of document.querySelectorAll('[data-exhd-panel]')) {
      if (panel.dataset.exhdReady) continue;
      panel.dataset.exhdReady = '1';
      const item = panel.closest('.menu-list__list-item') || panel;
      item.addEventListener('pointerenter', () => wake(panel), { passive: true });
      item.addEventListener('focusin', () => wake(panel));
      const peek = panel.querySelector('[data-exhd-peek]');
      if (!peek) continue;
      for (const a of panel.querySelectorAll('a[data-handle]')) {
        const show = async () => {
          if (!pointer.matches) return;
          for (const x of panel.querySelectorAll('.is-active')) x.classList.remove('is-active');
          a.classList.add('is-active');
          const d = await lookup(a.dataset.handle);
          if (!d || !a.classList.contains('is-active')) return;
          const url = new URL(d.src, location.href);
          url.searchParams.set('width', '480');
          const img = peek.querySelector('img');
          img.removeAttribute('data-src');
          img.src = url.toString();
          const cap = peek.querySelector('[data-exhd-cap]');
          if (cap) cap.textContent = d.title;
        };
        a.addEventListener('pointerenter', show);
        a.addEventListener('focus', show);
      }
    }
  };

  // 2. Lazy country list (Horizon's components pick injected items up by MutationObserver
  //    and delegated on:click, so they behave exactly like server-rendered ones).
  //    Listening at the document (not on the buttons) also covers drawer markup that Horizon
  //    creates or moves after load; every trigger fills any list that is still empty.
  let items = null;
  let loading = null;
  const fill = () => {
    if (!items) return;
    for (const list of document.querySelectorAll('ul[data-ex-lazy-countries]')) {
      const frag = document.createDocumentFragment();
      for (const li of items) frag.append(document.importNode(li, true));
      list.append(frag);
      list.removeAttribute('data-ex-lazy-countries');
      const search = list.closest('localization-form-component')?.querySelector('input[type="search"]');
      if (search && search.value) search.dispatchEvent(new KeyboardEvent('keyup', { bubbles: true }));
    }
  };
  const loadCountries = () => {
    if (items) { fill(); return Promise.resolve(); }
    if (loading) return loading;
    loading = fetch(`${root()}?section_id=ex-header-country-list`, { credentials: 'same-origin' })
      .then((r) => (r.ok ? r.text() : Promise.reject(new Error(String(r.status)))))
      .then((html) => {
        const found = [...new DOMParser().parseFromString(html, 'text/html').querySelectorAll('ul.countries > li')];
        if (!found.length) throw new Error('no countries in response');
        items = found;
        fill();
      })
      .catch(() => { loading = null; });
    return loading;
  };
  const TRIGGERS = '.dropdown-localization__button, #HeaderDrawer-localization, .drawer-localization__button, .header__icon--menu';
  const onTrigger = (event) => {
    const target = event.target instanceof Element ? event.target.closest(TRIGGERS) : null;
    if (target && document.querySelector('ul[data-ex-lazy-countries]')) loadCountries();
  };
  for (const type of ['pointerover', 'pointerdown', 'focusin', 'click']) document.addEventListener(type, onTrigger, { capture: true, passive: true });

  const boot = () => { armPanels(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
